<template>
  <div class="swiper-wrap">
    <div class="swiper">
      <div id="bannerSwiper" class="banner-swiper" aegis-first-screen-timing>
        <van-swipe ref="swiper" class="swiper-banner" indicator-color="#333" :loop="false" :show-indicators="showIndicator" @change="onChange">
          <van-swipe-item class="swiper-item" :key="image.id" v-for="(image, index) in swiperImg">
            <img v-if="image.baseImage" v-lazy="image.baseImage" @click="fnPreviewImage(index)" class="swiper-img" />
            <div id="swiperVideo" v-else-if="image.video" @click="videoClick(index)">
              <video
                  id="my-player"
                  class="video-js"
                  preload="auto"
                  controls
                  playsinline="true"
                  webkit-playsinline
                  x5-playsinline
                  x-webkit-airplay='allow'
                  x5-video-player-type='h5'
                  x5-video-orientation='portraint'
                  x5-video-player-fullscreen=''
                  :poster="playerOptions.poster">
                  <source :src="playerOptions.sources[0].src" type="video/mp4"/>
                  <p class="vjs-no-js">
                    To view this video please enable JavaScript, and consider upgrading to a
                    web browser that
                    <a href="https://videojs.com/html5-video-support/" target="_blank">
                      supports HTML5 video
                    </a>
                  </p>
              </video>
            </div>
            <template v-else>
              <img v-lazy="image" @click="fnPreviewImage(index)" class="swiper-img" />
            </template>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div id="playVideo" :class="{'small-video':smallVideoShow}" @touchstart="touchstart" @touchmove.stop.prevent="touchmove" @touchend="touchend">
        <span class="small-icon" @touchend.stop.prevent="changeVoince">
          <svg class="icon-svg small-voice" aria-hidden="true" v-show="isMuted" >
            <use xlink:href="#icon-ic_jingyin1"></use>
          </svg>
          <svg class="icon-svg small-voice" aria-hidden="true" v-show="!isMuted" >
            <use xlink:href="#icon-ic_shengyin1"></use>
          </svg>
        </span>
        <span class="small-icon small-close" @touchend.stop.prevent="closeSmallVideo">
          <svg class="icon-svg" aria-hidden="true">
            <use :xlink:href="$globalIcon.closeIconNew"></use>
          </svg>
        </span>
        <span class="small-icon small-full" @touchend.stop.prevent="smallVideoClick">
          <svg class="icon-svg" aria-hidden="true">
            <use xlink:href="#icon-ic_quanping"></use>
          </svg>
        </span>
        <div id="smallVideoWarp"></div>
      </div>
      <div class="custom-indicator">
        <span>{{ current + 1 }}</span> / {{swiperImg.length}}
      </div>
    </div>
    <div id="swiper-line"></div>
  </div>
</template>

<script>
// import { ImagePreview } from 'vant'
import 'video.js/dist/video-js.css'
import commons from '@/utils/commons.js'
import videojs from 'video.js'
// import { videoPlayer } from 'vue-video-player'
import { imageToHttps, imageThumb, imageToWebp } from '@/utils/filters'
import { PlatformTypes } from '@/config/constMaps'

let isMoveflag = false // 是否是手势拖动中

export default {
  inject: ['getCurScrollTop'],
  props: ['images', 'products', 'gioObject', 'firstImageInfo'],
  data() {
    return {
      startX: '',
      offsetX: '',
      offsetY: '',
      oldX: -1, // 上次位置
      oldY: -1, // 上次位置
      player: null, // 播放器
      fullBtn: null,

      videoErrToast: false, //视频出错提示

      prevInstance: null,
      current: 0,
      swiperImg: [],
      // videoSlide: false, // 是否banner切换视频
      smallVideoShow: '', // 是否切换小图视频
      fullSceen: false, // 全屏
      isCancelSmallVideo: false, // 是否取消小视频
      isMuted: true, // 是否静音
      showIndicator: false,
      interval: 2000,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: this.$util.isIos() ? 'auto' : 'none', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: '', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: '', // url地址
          },
        ],
        poster: '', // 你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: false, // 全屏按钮
          volumePanel: {
            inline: false
          }
        },
      },
    }
  },
  computed: {
    scrollTop() {
      return this.getCurScrollTop()
    },
  },
  mounted() {
    // 视频弹窗关闭
    let maskVideo = document.getElementById('maskVideo')
    let maskClose = document.getElementById('maskClose')
    if (maskClose) {
      maskClose.addEventListener('click', () => {
        let bannerSwiper = document.getElementById('bannerSwiper')
        if (bannerSwiper) {
          console.log(bannerSwiper, 'bannerSwiper')
          this.fullSceen = !this.fullSceen
          bannerSwiper.append && bannerSwiper.append(maskVideo.firstElementChild)
          maskVideo.classList.remove('active')
          this.$emit('sceenChange', this.fullSceen)
          this.scrollWatchFn(this.getCurScrollTop())
          // 处理安卓自动暂停问题
          let ispaused = false
          if (this.player?.paused && this.player.paused()) {
            ispaused = true
          } else {
            ispaused = false
          }
          try {
            !ispaused && this.player && this.player.play().catch(e=>this.videoErrToast = true)
          } catch (error) {}
        }
      })
    }
    this.resizeGuard = commons.swipeResize(this, 'swiper')
  },
  watch: {
    videoErrToast(newVal){
      if(newVal){
        this.$toast('为了您更好的体验，请设置允许视频播放')
      }
    },
    scrollTop(newVal) {
      this.scrollWatchFn(newVal)
      if (this.player && this.player !== null) {
        let site = document.getElementById('swiper-line')?.offsetTop;
        let video = document.getElementById('swiperVideo');
        let smallplay = document.getElementById('smallVideoWarp')
        // let site = 100
        // console.log(site, newVal)

        let ispaused = false
        if (this.player?.paused && this.player.paused()) {
          ispaused = true
        } else {
          ispaused = false
        }

        this.isMuted = this.player?.muted && this.player.muted()

        if (newVal > site && !this.isCancelSmallVideo) {
          this.smallVideoShow = true
          if (smallplay && typeof smallplay.append === 'function') smallplay.append(video?.firstElementChild)
          try {
            !ispaused && this.player.play().catch(e=>this.videoErrToast = true)
          } catch (error) {}
        // this.$nextTick(() => {
        //   let winW = window.innerWidth;
        //   let offsetW = document.getElementById('playVideo').offsetWidth
        //   if (this.oldX === -1 || this.oldY === -1) {
        //     this.oldX = winW - offsetW
        //     this.oldY = 100
        //   }
        //   document.getElementById('playVideo').style.left = this.oldX + 'px'
        //   document.getElementById('playVideo').style.top = this.oldY + 'px'
        // })
        } else {
          this.smallVideoShow = false
          if (video && typeof video.append === 'function') {
            video.append(smallplay?.firstElementChild)
          }
          try {
            !ispaused && this.player.play().catch(e=>this.videoErrToast = true)
          } catch (error) {}
        // document.getElementById('playVideo').style.left = 0
        // document.getElementById('playVideo').style.top = 0
        }
      }
    },
    images: {
      handler(newValue) {
        // if (typeof newValue[0] === 'object') {
        //   this.playerOptions.poster = newValue[0].img.replace('http:', 'https:')
        //   this.playerOptions.sources[0].src = newValue[0].video.replace('http:', 'https:')
        //   if (!this.player) {
        //     this.videoPlugins()
        //   }
        // }

        if (this.checkHasVideo()) {
          this.showIndicator = false
        }
        console.log(newValue, 'newValue')
        this.current = 0
        this.swiperImg = newValue.map((item, index) => {
          let src = imageToHttps(item.img ? item.img : (item.baseImage || item))
          if (src.indexOf('Signature') == -1) {
            src = imageThumb(src, 750)
            src = imageToWebp(src, this.$webpSurpport)
          }

          let swiperItem = {};
          if (item.img) {
            this.swiperVideo = item.video

            this.playerOptions.poster =  imageThumb(imageToWebp(item.img.replace('http:', 'https:'), this.$webpSurpport), 750)
            this.playerOptions.sources[0].src = item.video.replace('http:', 'https:')
            this.$nextTick(() => {
              if (this.player) {
                try {
                  this.player.dispose()
                } catch (error) {}
              }
              this.player = null
            })

            try {
              this.videoPlugins()
            } catch (error) {}

            swiperItem = {
              id: Math.random(),
              img: src,
              video: item.video,
            }
          } else {
            swiperItem = {
              id: Math.random(),
              src: src,
              loading: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/img_bg.png',
              error: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/img_bg.png'
            }
          }
          return swiperItem;
        })
        // console.log(this.swiperImg, 'watch swiperImg')
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    videoClick(index) {
      this.$util.gioTrackWithVariable('MB15620', {
        site_number: index + 1 + '',
        material_type: '视频'
      })
    },
    scrollWatchFn(newVal) {
      try {
        if (this.player) {
          let site = document.getElementById('swiper-line')?.offsetTop;
          let video = document.getElementById('swiperVideo');
          let smallplay = document.getElementById('smallVideoWarp')
          // let site = 100
          // console.log(site, newVal)

          let ispaused = false
          if (this.player?.paused && this.player.paused()) {
            ispaused = true
          } else {
            ispaused = false
          }
          // console.log(ispaused, '====ispaused isCancelSmallVideo====', this.isCancelSmallVideo)

          this.isMuted = this.player?.muted && this.player.muted()

          if (newVal > site && !this.isCancelSmallVideo) {
            this.smallVideoShow = true
            if (smallplay && typeof smallplay.append === 'function') {
              smallplay.append(video?.firstElementChild)
            }
            try {
              !ispaused && this.player.play && this.player.play().catch(e=>this.videoErrToast = true)
            } catch (error) {}
          // this.$nextTick(() => {
          //   let winW = window.innerWidth;
          //   let offsetW = document.getElementById('playVideo').offsetWidth
          //   if (this.oldX === -1 || this.oldY === -1) {
          //     this.oldX = winW - offsetW
          //     this.oldY = 100
          //   }
          //   document.getElementById('playVideo').style.left = this.oldX + 'px'
          //   document.getElementById('playVideo').style.top = this.oldY + 'px'
          // })
          } else {
            this.smallVideoShow = false
            if (video && typeof video.append === 'function') {
              video.append(smallplay?.firstElementChild)
            }
            try {
              !ispaused && this.player.play && this.player.play().catch(e=>this.videoErrToast = true)
            } catch (error) {}
          // document.getElementById('playVideo').style.left = 0
          // document.getElementById('playVideo').style.top = 0
          }
        }
      } catch (error) {

      }
    },

    touchstart(ev) {
      // console.log(ev, 'ev')
      if (this.smallVideoShow) {
        let startX = ev.touches[0].pageX;
        let startY = ev.touches[0].pageY;
        let offsetX = document.getElementById('playVideo').offsetLeft
        let offsetY = document.getElementById('playVideo').offsetTop;
        this.offsetX = startX - offsetX
        this.offsetY = startY - offsetY
      }
      // else {
      //   this.startX = ev.touches[0].pageX;
      // }
    },

    touchmove(ev) {
      isMoveflag = true
      if (this.smallVideoShow) {
        let moveX = ev.touches[0].pageX;
        let moveY = ev.touches[0].pageY;
        let left, top;
        let winW = window.innerWidth;
        let winH = window.innerHeight;
        let offsetH = document.getElementById('playVideo').offsetHeight
        let offsetW = document.getElementById('playVideo').offsetWidth
        if (moveX - this.offsetX > winW - offsetW) {
          left = winW - offsetW
        } else {
          left = (moveX - this.offsetX < 0) ? 0 : (moveX - this.offsetX)
        }
        if (moveY - this.offsetY < 0) {
          top = 50;
        } else {
          top = (moveY - this.offsetY > winH - offsetH) ? (winH - offsetH - 100) : moveY - this.offsetY
        }
        this.oldX = left;
        this.oldY = top
        document.getElementById('playVideo').style.left = left + 'px';
        document.getElementById('playVideo').style.top = top + 'px';
      }
      // else {
      //   let moveX = ev.touches[0].pageX;
      //   // console.log(this.startX - moveX)
      //   if (this.startX - moveX > 100 && this.swiperImg.length > 1) {
      //     console.log('swiper right')
      //     this.videoSlide = true
      //     document.getElementById('playVideo').style.top = 0
      //   }
      //   if (this.startX - moveX < -100 && this.current === 0) {
      //     console.log('swiper left')
      //     this.videoSlide = false
      //   }
      // }
    },
    touchend() {
      if (!isMoveflag) return
      isMoveflag = false
      let winH = window.innerHeight;
      let winW = window.innerWidth;
      let offsetW = document.getElementById('playVideo').offsetWidth
      let offsetH = document.getElementById('playVideo').offsetHeight
      this.offsetX = ''
      this.offsetY = ''
      this.startX = ''
      if (this.oldX > (winW - offsetW) / 2) {
        document.getElementById('playVideo').style.left = (winW - offsetW) + 'px';
      } else {
        document.getElementById('playVideo').style.left = 0 + 'px';
      }

      if (this.oldY < 50) {
        document.getElementById('playVideo').style.top = 50 + 'px';
      } else if (this.oldY > (winH - offsetH - 100)) {
        document.getElementById('playVideo').style.top = winH - offsetH - 100 + 'px';
      }
    },

    onChange(index) {
      this.current = index
      console.log(this.current, 'index+++++++')
      if (this.checkHasVideo() && index === 0) {
        // this.showIndicator = false
        // this.player && this.player.play()
      } else {
        // this.showIndicator = true
        this.player && this.player.pause()
      }
      this.$emit('swiperChange', index, this.showIndicator)
    },
    checkHasVideo() {
      let flag = false;
      if (this.products.videoUrl) {
        flag = true
      }
      return flag
    },
    fnPreviewImage(index) {
      this.$util.gioTrackWithVariable('MB15620', {
        site_number: index + 1 + '',
        material_type: '图片'
      })
      this.fullSceen = !this.fullSceen
      // 处理安卓自动暂停问题
      let ispaused = false
      if (this.player?.paused && this.player.paused()) {
        ispaused = true
      } else {
        ispaused = false
      }
      let maskVideo = document.getElementById('maskVideo')
      let bannerSwiper = document.getElementById('bannerSwiper');
      if (maskVideo && bannerSwiper) {
        if (this.fullSceen) {
          console.log(maskVideo, 'maskVideo')
          maskVideo.append && maskVideo.append(bannerSwiper.firstElementChild)
          maskVideo.classList.add('active')
          this.$emit('sceenChange', this.fullSceen)
          try {
            !ispaused && this.player && this.player.play().catch(e=>this.videoErrToast = true)
          } catch (error) {}
        } else {
          console.log(bannerSwiper, 'bannerSwiper')
          bannerSwiper.append && bannerSwiper.append(maskVideo.firstElementChild)
          maskVideo.classList.remove('active')
          this.$emit('sceenChange', this.fullSceen)
          try {
            !ispaused && this.player && this.player.play().catch(e=>this.videoErrToast = true)
          } catch (error) {}
        }
      }
    },

    videoPlugins() {
      let that = this
      let Button = videojs.getComponent('Button');
      this.fullBtn = videojs.extend(Button, {
        constructor: function (player, options) {
          let Button = videojs.getComponent('Button');
          Button.call(this, player, options);
          this.setAttribute('id', 'fullBtn');
        },
        handleClick: function (options) {
          console.log(options) // { name: 'customName' }
          that.fullSceen = !that.fullSceen

          // 处理安卓自动暂停问题
          let ispaused = false
          if (that.player?.paused && that.player.paused()) {
            ispaused = true
          } else {
            ispaused = false
          }
          let maskVideo = document.getElementById('maskVideo')
          let bannerSwiper = document.getElementById('bannerSwiper');
          if (maskVideo && bannerSwiper) {
            if (that.fullSceen) {
              console.log(maskVideo, 'maskVideo')
              maskVideo.append(bannerSwiper.firstElementChild)
              maskVideo.classList.add('active')
              that.$emit('sceenChange', that.fullSceen)
              try {
                !ispaused && that.player.play().catch(e=>this.videoErrToast = true)
              } catch (error) {}
            } else {
              console.log(bannerSwiper, 'bannerSwiper')
              bannerSwiper.append && bannerSwiper.append(maskVideo.firstElementChild)
              maskVideo.classList.remove('active')
              that.$emit('sceenChange', that.fullSceen)
              try {
                !ispaused && that.player.play().catch(e=>this.videoErrToast = true)
              } catch (error) {}
              that.scrollWatchFn(that.getCurScrollTop())
            }
          }
        },
        buildCSSClass: function () {
          return 'vjs-custom-control vjs-control vjs-button-full';
        }
      });
      videojs.registerComponent('fullBtn', this.fullBtn);

      this.$nextTick(() => {
        try {
          this.player = videojs('my-player', this.playerOptions, () => {
            console.log(this.player, 'videoplayer')
            this.player.getChild('controlBar').addChild('fullBtn', {}, 10);
          })

          this.player.on('waiting', () => {
            this.player?.el_ && this.player.el_.classList.add('vjs-seeking')
          })
          this.player.on('timeupdate', () => { // userinactive
            let delay = this.$util.isIos() ? 200 : 6000
            this.$util.setTimeOutFn(() => {
              this.player?.el_ && this.player.el_.classList.remove('vjs-seeking')
            }, delay)
          })
          this.player.on('play', () => {
            console.log('playing')
            this.$util.gioTrackWithVariable('MB15620', {
              site_number: '1',
              material_type: '视频'
            })
            this.$util.trackWithVariable({
              platformConf: {
                [PlatformTypes.SYN_APP | PlatformTypes.SYN_H5]: {
                  id: 'BD20191',
                  param: ['md_code', 'store_id', 'product_id', 'product_name', 'fk_code', 'fc_code', 'scene_name', 'origin']
                }
              }
            }, {
              md_code: this.gioObject?.mdCode,
              store_id: this.gioObject?.storeId,
              product_id: this.gioObject?.productId,
              product_name: this.gioObject?.productName,
              fk_code: this.gioObject?.fkCode,
              fc_code: this.gioObject?.fcCode,
              scene_name: 'null',
              origin: this.gioObject?.trkOrigin,
            }).then((res) => {
              console.log('BD20191', res);
            })
            this.$util.isWifi().then(isWifi => {
              if (!isWifi) {
                this.$toast('当前非Wifi播放，请注意流量消耗')
              }
            })
            this.isCancelSmallVideo = false
          })
          this.player.on('pause', () => {
            this.$util.trackWithVariable({
              platformConf: {
                [PlatformTypes.SYN_APP | PlatformTypes.SYN_H5]: {
                  id: 'BD20192',
                  param: ['md_code', 'store_id', 'product_id', 'product_name', 'fk_code', 'fc_code', 'scene_name', 'origin', 'vedio_time', 'page_stay_time']
                }
              }
            }, {
              md_code: this.gioObject?.mdCode,
              store_id: this.gioObject?.storeId,
              product_id: this.gioObject?.productId,
              product_name: this.gioObject?.productName,
              fk_code: this.gioObject?.fkCode,
              fc_code: this.gioObject?.fcCode,
              scene_name: 'null',
              origin: this.gioObject?.trkOrigin,
              vedio_time: this.player.duration().toFixed(2),
              page_stay_time: this.player.currentTime().toFixed(2),
            }).then((res) => {
              console.log('BD20192', res);
            })
          })
          // this.$util.isWifi().then(isWifi => {
          //   if (isWifi) {
          //     console.log('isWifi')
          //     this.player?.muted && this.player.muted(this.isMuted)
          //     try {
          //       this.player.play().catch(e=>this.videoErrToast = true)
          //     } catch (error) {}
          //   } else {
          //     console.log('not isWifi')
          //   }
          // })
        } catch(error) {
          
        }

        // this.$refs.refPlayer.player.getChild('controlBar').addChild('PrevButton', {}, 0);
      })
    },
  

    // 切换音量
    changeVoince() {
      this.isMuted = !this.isMuted
      this.player?.muted && this.player.muted(this.isMuted)
    },

    // 关闭小窗
    closeSmallVideo() {
      let video = document.getElementById('swiperVideo');
      let smallplay = document.getElementById('smallVideoWarp');
      this.smallVideoShow = false
      this.isCancelSmallVideo = true
      if (video) {
        video.append(smallplay.firstElementChild)
      }
      if (this.player?.paused && !this.player.paused()) {
        this.player.pause()
      }
    },

    smallVideoClick() {
      console.log('smallVideoClick')
      // 处理安卓自动暂停问题
      let ispaused = false
      if (this.player?.paused && this.player.paused()) {
        ispaused = true
      } else {
        ispaused = false
      }
      // if (!ispaused) {
      this.closeSmallVideo()
      this.isCancelSmallVideo = false
      let maskVideo = document.getElementById('maskVideo')
      let bannerSwiper = document.getElementById('bannerSwiper');
      if (maskVideo && bannerSwiper) {
        console.log(maskVideo, 'maskVideo')
        maskVideo.append(bannerSwiper.firstElementChild)
        maskVideo.classList.add('active')
        this.fullSceen = true
        this.$emit('sceenChange', true)
        try {
          !ispaused && this.player.play().catch(e=>this.videoErrToast = true)
        } catch (error) {}
      }
      // }
    }

  },
  beforeDestroy() {
    // this.fullBtn && this.fullBtn?.dispose()
    this.fullBtn = null
    videojs.registerComponent('fullBtn',
      videojs.extend(videojs.getComponent('Button'), {})
    );
    this.player && this.player.dispose()
    this.player = null;
    if (this.prevInstance) this.prevInstance.close()
    commons.removeSwipeResize(this.resizeGuard)
  }
}
</script>
<style>
.video-js .vjs-big-play-button .vjs-icon-placeholder:before{
  top: 2px;
}
</style>
<style lang="scss">
/* 调整播放器样式 */
.video-cus{
  width: 7.5rem;
  height: 7.5rem;
  position: absolute;
  left: 0;
  top: 0;
  width: 7.5rem;
  z-index: 10;
  transform: translateX(0);
  transition: transform .3s linear;
}
.video-js.vjs-fluid, .video-js.vjs-16-9, .video-js.vjs-4-3 {
  height: 100%;
}
.video-js{
  width: 100%;
  height: 100%;
}

video{
  width: 100%;
  height: 100%;
}

.small-video{
  position: fixed;
  top: 3rem !important;
  // left: 50%;
  right: 0;
  // transform: translateX(.6rem);
  width: 3.12rem;
  height: 1.76rem;
  z-index: 200;

  .small-icon{
    position: absolute;
    width: .5rem;
    height: .5rem;
    padding-left: .5rem;
    padding-top: .5rem;
    transform: translate(-50%,-50%);
    background: rgba(0,0,0,.7);
    border-radius: .5rem;
    z-index: 10;
  }
  .small-voice{
    margin-top: 0.04rem;
    margin-left: 0.04rem;
    display: inline;
    max-width: .36rem;
    max-height: .36rem;
    color:#fff;
  }
  .small-close{
    padding-left: 0;
    padding-right: .5rem;
    padding-top: .5rem;
    transform: translate(50%,-50%);
    right: 0;
    text-align: right;
    color:#fff;
    svg {
      margin-top: 0.08rem;
      margin-right: 0.06rem;
      max-width: 0.26rem;
      max-height: 0.26rem;
    }
  }
  .small-full{
    bottom: 0;
    padding-top: .1rem;
    padding-bottom: .5rem;
    transform: translate(-50%,50%);
    color:#fff;
    svg {
      max-width: .3rem;
      max-height: .3rem;
      margin-top: 0.08rem;
      margin-left: 0.06rem;
    }
  }
}
.small-video .video-player{
  height: 1.76rem;
}

.vjs-button-full{
  background: url(https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/goodsDetail/fullsceen.png) center center no-repeat !important;
  background-size: 40% !important;
}

.small-video .vjs-control-bar{
  display: none;
}
.video-js .vjs-control-bar {
  bottom: 35px;
}
/* 调整播放器样式 */
.video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: none;
  background-color: rgba(0, 0, 0, 0.5);
}
/*
.video-js{
  transform: translateZ(0)
}
.video-js video{
  transform: translateZ(0)
}
.video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: none;
  background-color: rgba(0,0,0,0.5);
}
.video-player{
  height: 7.5rem;
}
.video-cus .video-js.vjs-fluid, .video-js.vjs-16-9, .video-js.vjs-4-3 {
  height: 100%;
}
.video-cus{
  position: absolute;
  left: 0;
  top: 0;
  width: 7.5rem;
  z-index: 10;
  transform: translateX(0);
  transition: transform .3s linear;
}
.small-video{
  position: fixed;
  top: 1rem;
  right: 0;
  width: 3.12rem;
  height: 1.76rem;
  background: red;
  z-index: 200;
}
.small-video .video-player{
  height: 1.76rem;
}
.van-swipe__indicator {
  background-color: rgba(51, 51, 51, 0.4);
}
*/
</style>
<style lang="scss" scoped>
#swiperVideo{
  font-size: 0;
  overflow: hidden;
  height: 7.5rem;
}
#playVideo{
  height: 1.76rem;
  font-size: 0;
  overflow: hidden;
}
#smallVideoWarp{
  position: absolute;
  top: 0;
  left: 0;
  width: 3.12rem;
  height: 1.76rem;
  z-index: 2;
}

.swiper-wrap {
  position: relative;
  width: 7.5rem;
  background-color: #fff;
  overflow: hidden;
}

.swiper{
  position: relative;
  width: 7.5rem;
  height: 7.5rem;
}

.banner-swiper{
  width: 7.5rem;
  height: 100%;
  overflow: hidden;
}

.swiper-banner{
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 3;
}

.swiper-item{
  height: 7.5rem;
  width: 7.5rem;
}

.slide-hidden{
  transform: translateX(-200%);
}

img.swiper-img {
  // width: 100%;
  width:7.5rem;
  height: 7.5rem;
}

.swiper-wrap .sales {
  position: absolute;
  bottom: 0.32rem;
  right: 0.32rem;
  font-size: 0.24rem;
  color: rgba(255, 255, 255, 1);
  line-height: 0.4rem;
  height: 0.4rem;
  padding-left: 0.16rem;
  padding-right: 0.16rem;
  border-radius: 0.2rem;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.3);
}
.custom-indicator{
  width: 0.7rem;
  height: 0.32rem;
  font-size: 0.24rem;
  line-height: 0.32rem;
  text-align:center;
  background-color: rgba(0,0,0,.3);
  color: #fff;
  position: absolute;
  bottom: 24px;
  right: 0.2rem;
  border-radius: 0.28rem;
  z-index: 50;
}
</style>
